import {Link} from "gatsby";
import * as React from "react";

const SectionCard = ({ href, children }) => {
  return (
    <section className="text-center bg-white/80 hover:bg-white/90 transition duration-200">
      <Link to={href}>
        <div className="p-8">
          {children}
        </div>
      </Link>
    </section>
  );
}

export default SectionCard
